import { Button } from '@/components/ui/button';
import { login_path } from '@/rails/routes';
import { Link } from '@inertiajs/react';

interface PublishedApp {
  name: string;
  description: string | null;
  slug: string;
  companyName: string;
  lists: string[];
  // Read by the public layout, which shows the CAP Rock Labs mark in its footer.
  watermarked: boolean;
  publishedAt: string;
}

interface Props {
  app: PublishedApp;
}

// The front door of a published app. It belongs to the app's owner, so their names lead.
const Show = ({ app }: Props) => {
  return (
    <article>
      <header className="flex flex-col gap-2">
        <h1 className="authority-display text-4xl leading-tight break-words sm:text-5xl">
          {app.name}
        </h1>
        <p className="text-muted-foreground">by {app.companyName}</p>
      </header>

      {app.description ? (
        <p className="mt-6 text-lg leading-relaxed break-words whitespace-pre-line">
          {app.description}
        </p>
      ) : null}

      {app.lists.length > 0 ? (
        <section aria-labelledby="app-lists" className="mt-10">
          <h2 id="app-lists" className="text-muted-foreground text-sm">
            What it tracks
          </h2>
          <ul className="mt-2 border-t">
            {app.lists.map((list) => (
              <li key={list} className="border-b py-3">
                {list}
              </li>
            ))}
          </ul>
        </section>
      ) : null}

      <div className="mt-10">
        <Button asChild size="lg" className="w-full sm:w-fit">
          <Link href={login_path()}>Sign in</Link>
        </Button>
      </div>
    </article>
  );
};

export default Show;
